// extracted by mini-css-extract-plugin
module.exports = {"electionsNav":"styles_electionsNav__zVmgS"};